import ArticlesSection from "./components/landing/article/ArticleSection";
import ProductsSection from "./components/landing/products/ProductsSection.jsx";
import CoursesSection from "./components/landing/CoursesSection";
import ExamSection from "./components/landing/exam/examSection";
import NewsSection from "./components/landing/news/NewsSection";
import ProblemsSection from "./components/landing/problems/problemsSection";
import Navbar from "./components/Navbar";
import { SignupForm } from "./components/ui/signup-form";
import { Loginform } from "./components/ui/login-form";
import useTitle from "./hooks/useTitle";
import LottieAnimation from "./assets/lottie/Animation - 1746438530444.json";
import Lottie from "lottie-react";
// import ArticlesPage from "./components/articles/ArticlesPage.jsx";
import "./styles/main.css";
import "./styles/backgroundAnimation.css";
import { useEffect, useRef, lazy, Suspense, useState, useCallback } from "react";
import LandingPageFooter from "./components/landing/footer/landingPageFooter";
import MainFooter from "./components/mainfooter";
import { Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import TopLandingSection from "./components/landing/header/TopLandingSection";
import { IoClose } from "react-icons/io5";
import { TbVideo } from "react-icons/tb";
import { MdOutlineArticle, MdOutlineDarkMode } from "react-icons/md";
import { PiExam } from "react-icons/pi";
import { CgPoll } from "react-icons/cg";
import { FaQuestionCircle } from "react-icons/fa";
import { MdOutlineReportProblem } from "react-icons/md";
import { LiaBlogSolid } from "react-icons/lia";
import { MdOutlinePodcasts } from "react-icons/md";
import { BsBack } from "react-icons/bs";
import { BsInfoSquare } from "react-icons/bs";
import { MdOutlineLightMode } from "react-icons/md";
import ScrollToTop from "./components/lib/ScrollToTop.js";
import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock";
import "./styles/loadingAnimations.css";
import axios from "axios";
import { SupportField } from "./components/landing/supportField.jsx";
import { API_KEY } from "./secret/api.js";
import { IoIosArrowUp } from "react-icons/io";
import AiPage from "./components/ai/AiPage.jsx";
import TeamSection from "./components/landing/team/TeamSection.jsx";
import { supabase } from "./lib/supabaseClient";
import generateSlug from "./functions/slugGenerator.js";
const AdminPanel = lazy(() => import("./components/admin/AdminPanel.jsx"));
const AdminRoute = lazy(() => import("./components/admin/Admin.jsx"));
const AdminLogin = lazy(() => import("./components/admin/AdminLogin.jsx"));
const NotFound = lazy(() => import("./components/notfound/notFound.jsx"));
const FaqPage = lazy(() => import("./components/faq/faqPage.jsx"));
const CoursesPage = lazy(() => import("./components/courses/CoursesPage"));
const BlogPage = lazy(() => import("./components/blog/blogPage.jsx"));
const CoursesDetailsPage = lazy(() =>
  import("./components/courses/coursesDetailsPage")
);
const PodcastPage = lazy(() => import("./components/podcast/PodcastPage.jsx"));
const NewsDetailsPage = lazy(() =>
  import("./components/news/NewsDetailsPage.jsx")
);
const RatedExamLiveCodingPage = lazy(() =>
  import("./components/exam/rated/ratedExamLiveCoding.jsx")
);

const RatedExamsListPage = lazy(() =>
  import("./components/exam/rated/ratedExamsListPage.jsx")
);
const CoursePanel = lazy(() => import("./components/courses/coursePanel"));
const ArticlesPage = lazy(() => import("./components/articles/ArticlesPage"));
const ProductsPage = lazy(() => import("./components/products/ProductsPage.jsx"));
const ProductDetailsPage = lazy(() => import("./components/products/ProductDetailsPage.jsx"));
const ArticleDetailsPage = lazy(() =>
  import("./components/articles/ArticleDetailsPage")
);
const ChoeseExamMode = lazy(() => import("./components/exam/choeseMode"));
const PollPage = lazy(() => import("./components/poll/mainPollPage.jsx"));
const ExamsPage = lazy(() =>
  import("./components/exam/personal/PersonalExamsPage")
);
const ExamInfo = lazy(() => import("./components/exam/personal/page"));
const Exam = lazy(() => import("./components/exam/personal/exam/page"));
const ResultPersonalExam = lazy(() =>
  import("./components/exam/personal/result/resultPage")
);
const WorldMap = lazy(() =>
  import("./components/exam/rated/ratedExamPage.jsx")
);

const UserProblemDetails = lazy(() =>
  import("./components/problems/userProblemDetails.jsx")
);
const RatedTestExamPage = lazy(() =>
  import("./components/exam/rated/ratedTestExamPage.jsx")
);

const UsersProblemsPage = lazy(() =>
  import("./components/problems/userProblemsPage.jsx")
);
const AboutUs = lazy(() => import("./components/aboutus/AboutUsPage.jsx"));

const DashboardPage = lazy(() =>
  import("./components/dashboard/DashboardPage.jsx")
);

export default function App() {
  const [coursesData, setCoursesData] = useState([]);
  const [articlesData, setArticlesData] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  // Function to check and set the theme from localStorage or system preference
  const checkTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setIsDarkTheme(savedTheme === "dark");
    } else {
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      setIsDarkTheme(prefersDark);
    }
  };

  // Function to toggle and save the theme
  const toggleTheme = () => {
    setIsDarkTheme((prev) => {
      const newTheme = !prev;
      localStorage.setItem("theme", newTheme ? "dark" : "light");
      return newTheme;
    });
  };

  // Effect to set the initial theme and listen for system theme changes
  useEffect(() => {
    checkTheme(); // Set initial theme

    // Listen for system theme changes only if no theme is saved in localStorage
    const savedTheme = localStorage.getItem("theme");
    if (!savedTheme) {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleThemeChange = (e) => setIsDarkTheme(e.matches);
      mediaQuery.addEventListener("change", handleThemeChange);

      // Cleanup listener
      return () => mediaQuery.removeEventListener("change", handleThemeChange);
    }
  }, []);

  // Effect to apply the theme to the app
  useEffect(() => {
    if (isDarkTheme) {
      document.documentElement.classList.add("dark-theme");
      document.documentElement.classList.remove("light-theme");
    } else {
      document.documentElement.classList.add("light-theme");
      document.documentElement.classList.remove("dark-theme");
    }
  }, [isDarkTheme]);

  const dots = [
    {
      start: { lat: 37.7749, lng: -122.4194 }, // San Francisco
      end: { lat: 40.7128, lng: -74.006 }, // New York
    },
    {
      start: { lat: 51.5074, lng: -0.1278 }, // London
      end: { lat: 48.8566, lng: 2.3522 }, // Paris
    },
  ];
  const [isGoUpButtonShow, setIsGoUpButtonShow] = useState(
    window.scrollY > 100 ? true : false
  );

  // Scroll event listener with proper cleanup
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // Show if scrolled more than 100px
      if (scrollTop > 100) {
        setIsGoUpButtonShow(true);
      } else {
        setIsGoUpButtonShow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const refToken = localStorage.getItem("refToken") || "notLoggined";
  const [drawerToggle, setDrawerToggle] = useState(false);
  const [width, setWidth] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const bublesRef = useRef();
  const targetRef = useRef(null);
  const [users, setUsers] = useState([]);
  // State to handle loading state
  const [loading, setLoading] = useState(true);
  // State to handle errors
  const [error, setError] = useState(null);

  const handleOpenDrawer = useCallback(() => {
    if (targetRef.current) {
      try {
        disableBodyScroll(targetRef.current);
      } catch (err) {
        console.warn("Failed to disable body scroll", err);
      }
    }
    setDrawerToggle(true);
  }, [setDrawerToggle]);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(
        "https://retoolapi.dev/tPNiZj/tecama-users"
      );
      setUsers(response.data); // Set the fetched data to the state
      setLoading(false); // Set loading to false after data is fetched
    } catch (err) {
      setError(err.message); // Set error message if something goes wrong
      setLoading(false); // Set loading to false even if there's an error
    }
  };
  const handleCloseDrawer = useCallback(() => {
    if (targetRef.current) {
      enableBodyScroll(targetRef.current);
    }
    setDrawerToggle(false);
  }, [setDrawerToggle]);

  const shouldShowDrawer = drawerToggle && (width === null || width < 1300);

  useEffect(() => {
    if (width !== null && width >= 1300 && drawerToggle) {
      handleCloseDrawer();
    }
  }, [width, drawerToggle, handleCloseDrawer]);

  useEffect(() => {
    return () => {
      if (targetRef.current) {
        enableBodyScroll(targetRef.current);
      }
    };
  }, []);

  // useEffect(() => {
  //   let span = document.createElement("span");
  //   for (let j = 0; j <= 50; j++) {
  //     let bubles = document.querySelector(".bubles");
  //     span.style = `animation-duration: calc(400s / ${Math.floor(
  //       Math.random() * 50
  //     )});`;
  //     bubles.appendChild(span.cloneNode(true));
  //   }
  // }, []);
  useEffect(() => {
    fetchUsers();
    // fetch courses, articles, and news from supabase
    (async () => {
      // courses
      const { data: courses, error: coursesError } = await supabase
        .from("rahvan_courses")
        .select("*")
        .order("id", { ascending: true });
      if (!coursesError && courses) {
        const mappedCourses = courses.map((d) => ({
          id: d.id,
          cats: d.cats || [],
          titleImage: d.title_image,
          titleText: d.title_text,
          slug: d.slug || generateSlug(d.title_text),
          publisherImage: d.publisher_image,
          publisherName: d.publisher_name,
          publishTime: d.publish_time,
          meetsCount: d.meets_count || 0,
          time: d.time || "",
        }));
        setCoursesData(mappedCourses);
      }

      // articles
      const { data: articles, error: articlesError } = await supabase
        .from("rahvan_articles")
        .select("*")
        .order("id", { ascending: true });
      if (!articlesError && articles) {
        const mappedArticles = articles.map((d) => ({
          id: d.id,
          cats: d.cats || [],
          likesCount: d.likes_count || 0,
          commentsCount: d.comments_count || 0,
          articleImage: d.article_image,
          titleText: d.title_text,
          slug: d.slug || generateSlug(d.title_text),
          publisherImage: d.publisher_image,
          publisherName: d.publisher_name,
          publishTime: d.publish_time,
        }));
        setArticlesData(mappedArticles);
      }

      // news
      const { data: news, error: newsError } = await supabase
        .from("rahvan_news")
        .select("*")
        .order("id", { ascending: true });
      if (!newsError && news) {
        const mappedNews = news.map((d) => ({
          id: d.id,
          cats: d.cats || [],
          titleImage: d.title_image,
          titleText: d.title_text,
          slug: d.slug || generateSlug(d.title_text),
          publisherImage: d.publisher_image,
          publisherName: d.publisher_name,
          publishTime: d.publish_time,
          desc: d.description || null,
        }));
        setNewsData(mappedNews);
      }
    })();
    // fetch products from supabase
    (async () => {
      const { data, error } = await supabase
        .from("rahvan_products")
        .select("*")
        .order("display_order", { ascending: true, nullsFirst: false })
        .order("id", { ascending: true });
      if (!error && data) {
        const mapped = data.map((d) => ({
          id: d.id,
          cats: d.cats || [],
          likesCount: d.likes_count || 0,
          commentsCount: d.comments_count || 0,
          articleImage: d.article_image,
          titleText: d.title_text,
          slug: d.slug || generateSlug(d.title_text),
          content: d.content || "",
          description: d.description || "",
          shortDescription: d.short_description || null,
          summary: d.summary || null,
          publisherImage: d.publisher_image,
          publisherName: d.publisher_name,
          publishTime: d.publish_time,
          className: d.class_name,
          imageClassName: d.image_class_name,
          tagsClassName: d.tags_class_name,
          videoUrl: d.video_url || "",
        }));
        setProductsData(mapped);
      }
    })();
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // useEffect(() => {
  //   if (isDarkTheme) {
  //     document.body.classList.remove("light-theme");
  //     document.body.classList.add("dark-theme");
  //   } else {
  //     document.body.classList.add("light-theme");
  //     document.body.classList.remove("dark-theme");
  //   }
  // }, [isDarkTheme]);
  useTitle("رهوان | گروه نرم افزاری");
  return (
    <div ref={targetRef} className="relative">
      <AnimatePresence>
        {isGoUpButtonShow && (
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1.2 }}
            exit={{ opacity: 0, scale: 0.5, transition: { ease: "easeInOut", duration: 0.1, delay: 0.1 } }}
            transition={{ ease: "easeInOut", duration: 0.1, delay: 0.1 }}
            className={`cursor-pointer rounded-lg p-3 bg-blue-600 text-white fixed shadow-black shadow-2xl z-[9999] bottom-[20px] right-[20px]`}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <IoIosArrowUp size={20} />
          </motion.div>
        )}
      </AnimatePresence>
      <div className="rounded-[50px] w-[90%] md:w-[450px] h-[250px] opacity-[0] bg-[#18B2FA] blur-[120px] fixed right-[50%] translate-x-[50%] top-[200px] z-[-1]"></div>
      <div className="container-bubles">
        <div className="bubles" ref={bublesRef}></div>
      </div>
      <Navbar
        isDark={isDarkTheme}
        setIsDark={setIsDarkTheme}
        users={users}
        onOpenDrawer={handleOpenDrawer}
      />
      {shouldShowDrawer && (
        <div
          className="fixed inset-0 bg-[rgba(3,3,3,0.79)] z-[900]"
          onClick={handleCloseDrawer}
        />
      )}
      <AnimatePresence>
        {shouldShowDrawer ? (
          <motion.div
            key="drawer"
            initial={{ opacity: 0, x: 200 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{
              opacity: 0,
              x: 200,
              transition: { duration: 0.3, ease: "easeIn" },
            }}
            transition={{ duration: 0.3 }}
            dir="ltr"
            className={`drawer flex flex-col gap-y-[3px] fixed top-0 right-0 w-[260px] max-w-[80vw] rounded-l-xl border-[1px] border-slate-600 h-screen overflow-y-auto ${isDarkTheme ? "text-neutral-200" : "text-black"
              } ${isDarkTheme ? "bg-[#0F172A]" : "bg-[#EEF3F9]"} z-[1000]`}
          >
            <div className="w-[100%] flex items-center justify-between p-5">
              <div className="flex items-center gap-2">
                <div
                  className="cursor-pointer rounded-lg flex items-center justify-center w-[35px] h-[35px] border-[.8px] border-slate-700"
                  onClick={handleCloseDrawer}
                >
                  <IoClose size={25} />
                </div>
                <div
                  onClick={() => {
                    setIsDarkTheme((prev) => {
                      const next = !prev;
                      localStorage.setItem("theme", next ? "dark" : "light");
                      return next;
                    });
                    handleCloseDrawer();
                  }}
                  className="cursor-pointer rounded-lg flex items-center justify-center w-[35px] h-[35px] border-[.8px] border-slate-700"
                >
                  {isDarkTheme ? (
                    <MdOutlineLightMode size={20} />
                  ) : (
                    <MdOutlineDarkMode size={20} />
                  )}
                </div>
              </div>
              <img
                src={require("./assets/logo/logo.png")}
                alt="logo"
                width={55}
                height={55}
              />
            </div>

            <div
              onClick={() => {
                navigate("/about");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-5 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>درباره ما</h1>
              <BsInfoSquare size={20} />
            </div>
            <div
              onClick={() => {
                navigate("/products");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-5 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>محصولات ما</h1>
              <BsBack size={20} />
            </div>
            <div
              onClick={() => {
                navigate("/courses");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-3 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>ویدیو‌های آموزشی</h1>
              <TbVideo size={23} />
            </div>
            <div
              onClick={() => {
                navigate("/articles");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-3 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>مقالات علمی</h1>
              <MdOutlineArticle size={23} />
            </div>
            <hr className="border-slate-700 border-[1px] w-[100%] h-[1.3px] mt-3"></hr>
            <div
              onClick={() => {
                navigate("/exams");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-3 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>آزمون</h1>
              <PiExam size={23} />
            </div>
            <div
              onClick={() => {
                navigate("/poll");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-3 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>نظرسنجی</h1>
              <CgPoll size={23} />
            </div>
            <hr className="border-slate-700 border-[1px] w-[100%] h-[1.3px] mt-3"></hr>
            <div
              onClick={() => {
                navigate("/faq");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-3 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>سوالات پرتکرار</h1>
              <FaQuestionCircle size={23} />
            </div>
            <div
              onClick={() => {
                navigate("/problems");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-3 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>مشکلات کاربران</h1>
              <MdOutlineReportProblem size={23} />
            </div>
            <hr className="border-slate-700 border-[1px] w-[100%] h-[1.3px] mt-3"></hr>
            <div
              onClick={() => {
                navigate("/weblog");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-3 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>وبلاگ</h1>
              <LiaBlogSolid size={23} />
            </div>
            <hr className="border-slate-700 border-[1px] w-[100%] h-[1.3px] mt-3"></hr>
            <div
              onClick={() => {
                navigate("/podcasts");
                handleCloseDrawer();
              }}
              className="flex items-center justify-end mt-2 px-5 text-lg gap-2 cursor-pointer"
            >
              <h1>پادکست</h1>
              <MdOutlinePodcasts size={23} />
            </div>

            <div className="shrink-0 flex justify-end mt-5 px-5 text-lg gap-2">
              <h1
                className={`${isDarkTheme ? "text-slate-400" : "text-slate-700"
                  } text-[13px]`}
              >
                رهوان، تمامی حقوق محفوظ است ©
              </h1>
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
      <div className="fixed z-40 top-0 h-[3rem] backdrop-blur-xl" />
      <div className="h-[5rem]"></div>
      <AnimatePresence>
        <ScrollToTop />
        <Routes location={location} key={location.key}>
          <Route
            path="/"
            element={
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{
                  opacity: 0,
                  y: 50,
                  transition: { duration: 0.3, mease: "easeInOut" },
                }}
                transition={{ delay: 0.5, duration: 0.5 }}
                className="z-20"
              >
                <TopLandingSection isDarkTheme={isDarkTheme} />
                <ExamSection isDarkTheme={isDarkTheme} />
                <Suspense
                  fallback={
                    <div
                      className={`mt-5 flex items-center justify-center text-center flex-col`}
                    >
                      <div style={{ width: "300px", height: "170px" }}>
                        <Lottie
                          animationData={LottieAnimation}
                          loop={true}
                          autoplay={true}
                        />
                      </div>
                      <h1
                        className={`text-xl ${isDarkTheme ? "text-white" : "text-black"}`}
                      >
                        شکیبا باشید ...
                      </h1>
                    </div>
                  }
                >
                  <ProductsPage
                    isDarkTheme={isDarkTheme}
                    productsData={productsData}
                  />
                </Suspense>
                <TeamSection isDarkTheme={isDarkTheme} />
                {/* <CoursesSection
                  isDarkTheme={isDarkTheme}
                  coursesData={coursesData}
                /> */}
                {/* <ArticlesSection
                  isDarkTheme={isDarkTheme}
                  articlesData={articlesData}
                /> */}
                {/* <ProblemsSection isDarkTheme={isDarkTheme} /> */}
                {/* <NewsSection isDarkTheme={isDarkTheme} newsData={newsData} /> */}
                {/* <PodcastLandingPage isDarkTheme={isDarkTheme} /> */}
                <div className="h-[50px]"></div>
                <LandingPageFooter isDarkTheme={isDarkTheme} />
                <div className="h-[50px] md:h-[100px]"></div>
                <SupportField isDarkTheme={isDarkTheme} />
              </motion.div>
            }
          />
          // admin panel Routes
          <Route
            path="/admin"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <AdminRoute isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFound isDarkTheme={isDarkTheme} />} />
          <Route
            path="/admin/login"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <AdminLogin isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <AdminPanel isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/poll"
            element={<PollPage isDarkTheme={isDarkTheme} />}
          />
          <Route
            path="/not-found"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <NotFound isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <DashboardPage isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/news/:news_title"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <NewsDetailsPage isDarkTheme={isDarkTheme} newsData={newsData} API_KEY={API_KEY} />
              </Suspense>
            }
          />
          <Route path="/ai" element={<AiPage isDarkTheme={isDarkTheme} users={users} />} />
          <Route
            path="/problems"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <UsersProblemsPage isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/problems/:problem_title"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <UserProblemDetails isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/faq"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <FaqPage isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/weblog"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <BlogPage
                  isDarkTheme={isDarkTheme}
                  coursesData={coursesData}
                  articlesData={articlesData}
                  newsData={newsData}
                />
              </Suspense>
            }
          />
          <Route
            path="/podcasts"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <PodcastPage isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/about"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <AboutUs isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route path="/about_creator" element={<Navigate to="/about" replace />} />
          <Route
            path="/courses"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <CoursesPage
                  isDarkTheme={isDarkTheme}
                  coursesData={coursesData}
                />
              </Suspense>
            }
          />
          <Route
            path="/courses/:title"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <CoursesDetailsPage
                  isDarkTheme={isDarkTheme}
                  coursesData={coursesData}
                  API_KEY={API_KEY}
                />
              </Suspense>
            }
          />
          <Route
            path="/courses/:title/course-panel"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <CoursePanel isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/articles"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ArticlesPage
                  isDarkTheme={isDarkTheme}
                  articlesData={articlesData}
                />
              </Suspense>
            }
          />
          <Route
            path="/products"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"}`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ProductsPage
                  isDarkTheme={isDarkTheme}
                  productsData={productsData}
                />
              </Suspense>
            }
          />
          <Route
            path="/exams/rated/:title"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <RatedTestExamPage
                  isLogin={refToken}
                  isDarkTheme={isDarkTheme}
                />
              </Suspense>
            }
          />
          <Route
            path="/exams/rated/live-coding/:title"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <RatedExamLiveCodingPage isLogin={refToken} />
              </Suspense>
            }
          />
          <Route
            path="/articles/:title"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ArticleDetailsPage
                  isDarkTheme={isDarkTheme}
                  articlesData={articlesData}
                  API_KEY={API_KEY}
                />
              </Suspense>
            }
          />
          <Route
            path="/products/:title"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"}`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ProductDetailsPage
                  isDarkTheme={isDarkTheme}
                  productsData={productsData}
                  API_KEY={API_KEY}
                />
              </Suspense>
            }
          />
          <Route
            path="/exams"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ChoeseExamMode isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/exams/rated/exams-list"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <RatedExamsListPage isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/exams/personal"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ExamsPage isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/exams/personal/:lang"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ExamInfo isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/exams/personal/:lang/result"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <ResultPersonalExam isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/exams/personal/:lang/:panel-name"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <Exam isLoggin={refToken} isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/exams/rated"
            element={
              <Suspense
                fallback={
                  <div
                    className={`mt-5 flex items-center justify-center text-center flex-col`}
                  >
                    <div style={{ width: "300px", height: "170px" }}>
                      <Lottie
                        animationData={LottieAnimation}
                        loop={true}
                        autoplay={true}
                      />
                    </div>
                    <h1
                      className={`text-xl ${isDarkTheme ? "text-white" : "text-black"
                        }`}
                    >
                      شکیبا باشید ...
                    </h1>
                  </div>
                }
              >
                <WorldMap dots={dots} isDarkTheme={isDarkTheme} />
              </Suspense>
            }
          />
          <Route
            path="/login"
            element={
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{
                  opacity: 0,
                  y: 50,
                  transition: { duration: 0.3, mease: "easeInOut" },
                }}
                transition={{ delay: 0.5, duration: 0.5 }}
                className="h-[27rem] flex items-center justify-center"
              >
                <Suspense>
                  <Loginform isDarkTheme={isDarkTheme} />
                </Suspense>
              </motion.div>
            }
          />
          <Route
            path="/register"
            element={
              <Suspense>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{
                    opacity: 0,
                    y: 50,
                    transition: { duration: 0.3, mease: "easeInOut" },
                  }}
                  transition={{ delay: 0.5, duration: 0.5 }}
                  className="h-[43rem] flex items-center justify-center"
                >
                  <SignupForm isDarkTheme={isDarkTheme} />
                </motion.div>
              </Suspense>
            }
          />
        </Routes>
      </AnimatePresence>

      <MainFooter isDark={isDarkTheme} />
    </div>
  );
}
